import { tv } from 'tailwind-variants';

export const listHeaderVariants = tv({
  slots: {
    root: 'gap-xs inline-flex items-center whitespace-nowrap justify-center',
    label: 'text-xs flex-1 font-xs font-semibold',
  },
  variants: {
    size: {
      small: { root: 'px-sm py-3xs' },
      default: { root: 'px-sm py-xs' },
    },
  },
  defaultVariants: {
    size: 'default',
  },
});
